// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iEIr","rootMobile":"styles_rootMobile__1Jn7m"};